import { useEffect, useState } from "react";
import { useCitiesList } from "@/v2/stores";

interface RemappedCity {
  label: string;
  value: number;
}

interface UseRemapCitiesReturn {
  remappedCities: RemappedCity[];
}

export function useRemapCities(): UseRemapCitiesReturn {
  const [remappedCities, setRemappedCities] = useState<RemappedCity[]>([]);
  const cityList = useCitiesList();

  useEffect(() => {
    const buildCityList: RemappedCity[] = [];
    cityList.map((value: { name: string; id: number }) => {
      buildCityList.push({
        label: value.name,
        value: value.id,
      });
    });
    setRemappedCities(buildCityList);
  }, [cityList]);

  return { remappedCities };
}
